import { Component } from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-change-log',
    imports: [MatCardModule, MatDividerModule],
    templateUrl: './change-log.component.html',
    styleUrls: ['./change-log.component.scss']
})
export class ChangeLogComponent {

}
